import React from "react";
import PropTypes from "prop-types";
import { NavBar, NavItem } from "discover.medical.react-component-library";
import { Container, InnerContainer, Label } from "./styled";
import { isActive, getLinkProps } from "../../../../utils/navigationHelper";
import EventBus from "js-event-bus";

export const NavigationMenu = ({
  links = [],
  isHidden = false,
  pathname,
  eventBus
}) => {
  return (
    <Container isHidden={isHidden} data-testid="navigation-menu">
      <InnerContainer>
        <NavBar aria-label="main">
          {links.map((link) => (
            <NavItem
              key={link.label}
              label={<Label dangerouslySetInnerHTML={{ __html: link.label }} />}
              menuPositionRight={link.options?.isRightMenu}
              positionRight={link.options?.isRightMenu}
              active={isActive(link, pathname)}
              {...(!link.options?.isDropdown &&
                getLinkProps(link, links, pathname, { eventBus }))}
            >
              {link.options?.isDropdown &&
                link.options?.dropdownItems?.map((item) => (
                  <NavItem
                    key={item.label}
                    label={
                      <Label dangerouslySetInnerHTML={{ __html: item.label }} />
                    }
                    {...getLinkProps(item, links, pathname, { eventBus })}
                  />
                ))}
            </NavItem>
          ))}
        </NavBar>
      </InnerContainer>
    </Container>
  );
};

NavigationMenu.propTypes = {
  links: PropTypes.array,
  isHidden: PropTypes.bool,
  pathname: PropTypes.string,
  eventBus: PropTypes.object
};

export default NavigationMenu;
